module.exports = "{{ data | json }}\r\n"